module.exports = __webpack_public_path__ + "static/media/shape_02.72b64de6.png";